import "core-js/stable";
import WebpackerReact from 'webpacker-react';
import {ShippingSelectorRoot, CheckoutOrderTotal, CartItemQuantity, TileAddToCart, AddressEditor, GlobalSearchAutoSuggest, ProductLightbox} from './app'

import "@stimulus/polyfills"
import Turbolinks from 'turbolinks'

Turbolinks.start();
WebpackerReact.setup({ ShippingSelectorRoot, CheckoutOrderTotal, TileAddToCart , CartItemQuantity, AddressEditor, GlobalSearchAutoSuggest, ProductLightbox});

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

// Look for controllers inside app/javascripts/packs/controllers/
const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context));
